import title from "../media/images/workstationsT.png";
import image2 from "../media/images/workstationsB.jpg";
import "./Workstations.css"
const Workstations = () => {
    return (  
        <div className="workstations">
        <div className="workstationsPage">
            <div className="workTitle">
                <img src={title} alt="d"/>
            </div>
            <div className="workText" >
                 <div className="blockText">
                    <div className="workBigText">
                        <p >CUSTOMIZED</p>
                        <p >ERGONOMIC WORKSTATIONS</p>     
                    </div>
                    <div className="workSmall">
                        <p>
                            📢 Enhance performance and productivity with our ergonomic workstation solutions❗️<br/>

                            🔧 We’ve designed, manufactured, and delivered fully modular solutions in a very short time, according to the client’s requirements, in order to implement new ergonomic solutions in production.<br/>

                            💡 We can offer you customized solutions tailored to your needs. Contact us so we can analyze and identify your requirements together and design the perfect system for you❗<br/>
                        </p>
                    </div>
                </div>
                <div className="workBlockImage">
                    <img  src={image2} alt=""/>
                </div>
            </div>
            <div className="workBlockImagePhone">
                <img  src={image2} alt=""/>
            </div>
            <div className="workCBlockK" >
                <p>©Ecomode Studio 2025 - All Rights reserved</p>
            </div>
        </div>
        </div>
    );
}
 
export default Workstations;